<template>
    <div class="product-description-container">
        <div class="product-attributes">
            <template v-for="(value, key) in product.jersey_product_attributes" :key="key"> 
                <div v-if="key == 'unitcontent' && value != ''">{{value}}</div>
                <div v-if="key == 'abv' && value != ''">ABV {{value}}</div>
                <div v-if="key == 'Vegetarian' && value" class='circle'>V</div>
                <div v-if="key == 'Vegan' && value" class='circle'>VE</div>
                <template v-if="key == 'Country Of Origin' && value">
                    <DynamicImageContainer class="flag-image" :image='"flags/"+value'/>
                </template>
            </template>
        </div>
        <div class="description">{{ product.details }}</div>
    </div>
</template>
<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props: ['product']
}
</script>

<style lang="scss" scoped>
.product-description-container{
    margin-top: 10px;
    margin-bottom: 30px;
}
.description{
    font-size: 0.95rem;
    line-height: 24px;
    max-width: 900px;
}

.product-attributes{
    display: flex;
    gap: 15px;
    margin-bottom: 10px;
    color: #830100;
    font-size: 1.12rem;
    font-weight: 600;
    align-items: center;
}
.flag-image{
    width: 33px;
    height: 33px;
}
.circle{
    width: 33px;
    height: 33px;
    border-radius: 50%;
    text-align: center;
    color: #ffffff;
    line-height: 34px;
    background: #A13C59;
}
</style>